export default {
    'TEST': {
        'TEST-TOAST-1': {
            actionType: 'toast',
            message: {
                fr: 'Une erreur est survenue lors de la connexion.',
                en: 'An error occurred while logging in.',
            },
        },
        'TEST-REDIRECTION-1': {
            actionType: 'redirect',
            redirectPath: '/login',
            message: {
                fr: 'Vous devez être connecté pour accéder à cette ressource.',
                en: 'You must be logged in to access this resource.',
            },
        },
        'TEST-TOAST-2': {
            actionType: 'toast',
            message: {
                fr: 'Le challenge n\'a pas été trouvé.',
                en: 'The challenge was not found.',
            },
        },
        'TEST-REDIRECTION-2': {
            actionType: 'redirect',
            redirectPath: '/',
            message: {
                fr: 'Cette ressource n\'est plusaccessible',
                en: 'This resource is no longer accessible',
            },
        },
    },
};
